import { supabase } from "@/integrations/supabase/client";

export interface AuditLogData {
  action: string;
  table_name?: string;
  record_id?: string;
  old_values?: Record<string, any>;
  new_values?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
  function_name?: string;
}

export async function logAuditEvent(data: AuditLogData): Promise<void> {
  // Audit logging not available - log_audit_event function doesn't exist
  console.log("[AUDIT]", data.action, data);
}

// Alias for auth-specific events
export function logAuthEvent(action: string, data?: Record<string, any>): Promise<void> {
  return logAuditEvent({
    action,
    ...(data || {}),
  });
}
